import { useState } from 'react';
import { Modal, Textarea, Group, Button, Text } from '@mantine/core';
import type { HealthAlert } from '../../../../types';

interface AddressAlertModalProps {
  opened: boolean;
  onClose: () => void;
  alert: HealthAlert | null;
  onConfirm: (alert: HealthAlert, note?: string) => void;
  loading?: boolean;
}

export function AddressAlertModal({ opened, onClose, alert, onConfirm, loading }: AddressAlertModalProps) {
  const [note, setNote] = useState('');

  const handleConfirm = () => {
    if (!alert) return;
    onConfirm(alert, note.trim() || undefined);
    setNote('');
  };

  const handleClose = () => {
    setNote('');
    onClose();
  };

  return (
    <Modal opened={opened} onClose={handleClose} title="Mark as Addressed" size="sm">
      {alert && (
        <>
          <Text size="sm" c="dimmed" mb="md">
            {alert.title}: {alert.description}
          </Text>
          <Textarea
            label="Note (optional)"
            placeholder="Describe how this concern was addressed..."
            value={note}
            onChange={(e) => setNote(e.currentTarget.value)}
            minRows={3}
            maxRows={5}
          />
          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button color="medleyGreen" onClick={handleConfirm} loading={loading}>
              Mark as Addressed
            </Button>
          </Group>
        </>
      )}
    </Modal>
  );
}
